// Static sample data for the /preview page. Not personalized — for illustration only.
export const SAMPLE_SCORES = {
  authority_score: 3.2,
  authority_reading: "average",
  habit_mean: 3.1,
  trait_mean: 3.4,
  effect_mean: 3.1,
  habit_scores: {
    Space: 3.6,
    Structure: 2.4,
    Style: 3.5,
    Relationships: 3.8,
    Finances: 2.2,
  },
  trait_scores: {
    "Self-Assurance": 3.4,
    Discipline: 2.6,
    Initiative: 3.8,
    Appreciation: 3.7,
    Vitality: 3.5,
  },
  effect_scores: {
    "Body Language": 3.4,
    Appearance: 3.6,
    Aura: 3.1,
    Presence: 2.6,
    Congruence: 2.8,
  },
  bottleneck: { zone: "Finances", score: 2.2, reading: "weak" },
  situational_composure: [
    { trait: "Self-Assurance", spread: 3, inconsistency: "high" },
  ],
  no_data_traits: [],
};

export const SAMPLE_REPORT = {
  headline: "Authority Score 3.2 / 5 — bottleneck at Finances (2.2). The instrument's own room-first, money-last order is intact but you have paused at the last step.",
  paragraphs_masked: [
    "Your Authority Score is 3.2 / 5 — the mid-signal band where presence exists but does not compound. Where the three means disagree, believe the lowest; the model reads authority as a system throttled by its weakest layer, and yours is habit, not trait.",
    "Your strongest habit zone is Relationships at 3.8 / 5, which currently carries a disproportionate share of your perceived authority — most people you meet register your social composure first.",
    "The bottleneck is Finances at 2.2 / 5. Habits are the causal lever in this model, so weakness here caps every trait and effect marker that depends on stability under pressure.",
    "Self-Assurance shows a high inconsistency (spread 3) — the ability exists, but a trigger switches it off. Name the trigger before working on the ability itself.",
    "Prescription: restrict scope. Do less across the other four zones and rebuild Finances to a floor of 3.5 / 5 before diversifying attention.",
  ],
  action_plan_masked: [
    { priority: 1, action: "Set up a 90-day forecast budget in a single spreadsheet. Update it every Sunday, no exception.", timeframe: "7 days" },
    { priority: 2, action: "Automate a fixed savings transfer on every payday — even a nominal amount. Consistency is the training.", timeframe: "14 days" },
    { priority: 3, action: "Cancel two recurring subscriptions today. The specific two do not matter — the act of pruning matters.", timeframe: "30 days" },
    { priority: 4, action: "Post one three-sentence self-review to your own inbox every Sunday for the whole quarter.", timeframe: "Ongoing" },
    { priority: 5, action: "Re-score the assessment. Do not retake before then.", timeframe: "90 days" },
  ],
};
